class VideoCard extends HTMLElement {
  protected button: HTMLElement | null = null;
  protected dialog: HTMLDialogElement | null = null;
  protected video: HTMLVideoElement | null = null;
  protected backdrop: HTMLElement | null = null;

  connectedCallback() {
    this.button = this.querySelector('[data-play]');
    if (!this.button) return;

    const dialogTarget = this.button.getAttribute('data-lightbox-target');
    this.dialog = dialogTarget ? this.querySelector<HTMLDialogElement>(dialogTarget) : null;
    this.video = this.dialog?.querySelector('video') ?? null;
    this.backdrop = this.dialog?.querySelector('[data-lightbox-backdrop]') ?? null;

    if (!this.dialog || !this.video) return;

    this.button.addEventListener('click', this.openLightbox.bind(this));

    this.dialog.addEventListener('close', this.handleClose.bind(this));

    // Intercept native Escape close so the video always gets reset consistently
    this.dialog.addEventListener('cancel', (event) => {
      event.preventDefault();
      this.dialog?.close();
    });

    this.dialog.querySelector('[data-lightbox-close]')?.addEventListener('click', () => this.dialog?.close());

    // Close when clicking the backdrop (outside the video/panel)
    this.dialog.addEventListener('click', (event) => {
      if (event.target === this.dialog || event.target === this.backdrop) this.dialog?.close();
    });
  }

  openLightbox() {
    if (!this.dialog || !this.video) return;

    window.pauseAllMedia();
    window.scrollLock();
    this.dialog.showModal();
    this.video.play();
  }

  handleClose() {
    if (!this.video) return;
    this.video.pause();
    this.video.currentTime = 0;
    window.scrollUnlock();
  }
}

if (!customElements.get('video-card')) {
  customElements.define('video-card', VideoCard);
}
